export const TOGGLE_DRAWLER_SIDEBAR_LEFT = '[APP]TOGGLE_DRAWLER_SIDEBAR_LEFT';
export const REGISTER_SOCKET_ID = `[APP]REGISTER_SOCKET_ID`;
export const SET_OPEN_LOGOUT_POPUP = `[APP]SET_OPEN_LOGOUT_POPUP`;

export const SET_THEME_NAME = `[APP]SET_THEME_NAME`;
export const SET_FONT_SIZE = `[APP]SET_FONT_SIZE`;
export const TOGGLE_SECURE_PHONE = `[APP]TOGGLE_SECURE_PHONE`;
